import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=6f1c57a6"
import script from "./user-statistics.ts?vue&type=script&lang=ts&external"
export * from "./user-statistics.ts?vue&type=script&lang=ts&external"
import style0 from "./user-statistics.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports